import React from 'react';

import './Step.scss';

export const AuthBackUpCodes = () => {
    return (
        <>
            <h2 className="two-factor-auth-step__title">Backup Codes</h2>
        </>
    );
};
